import { Card, CardContent, Grid, Typography } from '@mui/material';

export default function ComprasResumen({ compras }) {
  const total = compras
    .filter(c => c.estado === 'ACTIVA')
    .reduce((a, b) => a + Number(b.monto), 0);

  const anuladas = compras.filter(c => c.estado === 'ANULADA').length;

  return (
    <Grid container spacing={2} sx={{ mb: 2 }}>
      <Grid item xs={6}>
        <Card>
          <CardContent>
            <Typography>Total Compras</Typography>
            <Typography variant="h5">{total.toFixed(2)}</Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={6}>
        <Card>
          <CardContent>
            <Typography>Anuladas</Typography>
            <Typography variant="h5">{anuladas}</Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}
